// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__6Z41- {
  position: relative;
  display: inline-block; }
`, "",{"version":3,"sources":["webpack://./src/modules/mapal/submodules/features/components/FeatureFormButton/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,kBAAkB;EAClB,qBAAqB,EAAA","sourcesContent":[".container {\n    position: relative;\n    display: inline-block;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__6Z41-`
};
export default ___CSS_LOADER_EXPORT___;
